module.exports = __webpack_public_path__ + "static/media/placeholder.c989935a.jpg";